import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false,
  isUserLogout: true,
  successMsg: null,
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    registerUserSuccessful(state: any, action: PayloadAction<string>) {
      // state.user = action.payload.user;
      state.loading = false;
      state.success = true;
      state.successMsg = action.payload;
      state.error = false;
    },
    registerUserFailed(state: any, action: any) {
      state.user = null;
      state.loading = false;
      state.successMsg = null;
      state.error = action?.payload;
    },
    resetRegisterFlagChange(state: any) {
      state.success = false;
      state.error = false;
    },
    apiErrorChange(state: any, action: any) {
      state.error = action.payload;
      state.loading = false;
      state.isUserLogout = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange,
  setLoading,
} = registerSlice.actions;

export default registerSlice.reducer;
